(function () {
  if (window.__SIMPLE_CHATBOT_EMBED_LOADED__) return;
  window.__SIMPLE_CHATBOT_EMBED_LOADED__ = true;

  var scriptEl = document.currentScript;
  var cfg = window.ChatbotConfig || {};

  function pick(name, fallback) {
    var attrName = "data-" + name.replace(/[A-Z]/g, function (m) {
      return "-" + m.toLowerCase();
    });
    if (scriptEl && scriptEl.getAttribute(attrName)) {
      return scriptEl.getAttribute(attrName);
    }
    if (cfg[name] !== undefined && cfg[name] !== null && cfg[name] !== "") {
      return cfg[name];
    }
    return fallback;
  }

  var webhookUrl = pick("webhookUrl", "");
  var title = pick("title", "Chat");
  var subtitle = pick("subtitle", "How can we help?");
  var toggleLabel = pick("toggleLabel", "Chat");
  var placeholder = pick("placeholder", "Write a message...");
  var welcomeMessage = pick("welcomeMessage", "Hi! How can we help?");
  var sendLabel = pick("sendLabel", "Send");
  var accent = pick("accentColor", "#2563eb");
  var textColor = pick("textColor", "#111111");
  var zIndex = pick("zIndex", "9999");

  if (!webhookUrl) {
    console.warn("[Simple Chatbot] Missing webhookUrl. Widget not started.");
    return;
  }

  var SESSION_KEY = "simple_chatbot_session_id";
  var OPEN_KEY = "simple_chatbot_open";
  var HISTORY_KEY = "simple_chatbot_history";
  var ACTIVITY_KEY = "simple_chatbot_last_activity";
  var INACTIVITY_TTL_MS = 900 * 1000;
  var HISTORY_LIMIT = 50;
  var sending = false;

  function sessionId() {
    try {
      var current = localStorage.getItem(SESSION_KEY);
      if (current) return current;
    } catch (e) {}

    var id =
      window.crypto && window.crypto.randomUUID
        ? window.crypto.randomUUID()
        : "sess-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10);
    try {
      localStorage.setItem(SESSION_KEY, id);
    } catch (e2) {}
    return id;
  }

  function addStyles() {
    var css = [
      ".scb-root{position:fixed;right:16px;bottom:16px;z-index:" + zIndex + ";font-family:system-ui,-apple-system,Segoe UI,Roboto,sans-serif;color:" + textColor + "}",
      ".scb-root,.scb-root *{box-sizing:border-box}",
      "html.scb-lock-scroll,body.scb-lock-scroll{overflow:hidden !important;overscroll-behavior:none;height:100%}",
      "body.scb-lock-scroll{touch-action:none}",
      ".scb-backdrop{display:none;position:fixed;top:0;left:0;width:100%;height:100%;background:#fff;pointer-events:none;overflow:hidden;z-index:1}",
      ".scb-toggle{background:#fff;color:" + textColor + ";border-radius:999px;padding:10px 16px;font-weight:700;cursor:pointer;box-shadow:0 4px 16px rgba(0,0,0,.12)}",
      ".scb-panel{position:absolute;right:0;bottom:0;width:min(360px,calc(100vw - 24px));height:min(520px,70vh);background:#fff;border:1px solid #e5e7eb;border-radius:14px;display:none;flex-direction:column;overflow:hidden;overscroll-behavior:contain;box-shadow:0 16px 40px rgba(0,0,0,.18);z-index:2}",
      ".scb-root.open .scb-panel{display:flex}.scb-root.open .scb-toggle{display:none}",
      ".scb-header{padding:12px 14px;border-bottom:1px solid #e5e7eb;display:flex;justify-content:space-between;gap:8px;background:#f8fafc;color:" + textColor + "}",
      ".scb-title{font-weight:700;font-size:14px;color:" + textColor + "}.scb-sub{font-size:12px;color:#6b7280}",
      ".scb-close{border:0;background:transparent;font-size:20px;line-height:1;cursor:pointer;color:#6b7280}",
      ".scb-messages{flex:1;overflow:auto;padding:10px;background:#f5f6f9;overscroll-behavior:contain;-webkit-overflow-scrolling:touch}",
      ".scb-row{display:flex;margin-bottom:8px}.scb-row.user{justify-content:flex-end}",
      ".scb-bubble{max-width:80%;padding:11px 20px;border-radius:20px;border:1px solid #e5e7eb;background:#fff;font-size:14px;line-height:1.35;white-space:pre-wrap;color:" + textColor + "}",
      ".scb-bubble,.scb-bubble p,.scb-bubble li,.scb-bubble strong,.scb-bubble em,.scb-bubble a{font-size:14px;line-height:1.35}",
      ".scb-bubble p{margin:0 0 10px}.scb-bubble p:last-child{margin-bottom:0}",
      ".scb-bubble strong{font-weight:800}",
      ".scb-bubble em{font-style:italic}",
      ".scb-bubble ul{margin:8px 0 10px;padding:0;list-style:none}",
      ".scb-bubble li{position:relative;padding-left:16px;margin:6px 0;line-height:1.45}",
      ".scb-bubble li::before{content:'';position:absolute;left:0;top:.62em;width:7px;height:7px;border-radius:50%;background:" + accent + "}",
      ".scb-bubble a{color:" + textColor + ";text-decoration:underline}",
      ".scb-bubble a:hover{color:" + accent + "}",
      ".scb-row.user .scb-bubble{background:" + accent + ";color:" + textColor + ";border-color:" + accent + "}",
      ".scb-bubble.loading{display:inline-flex;align-items:center;gap:4px;min-width:54px}",
      ".scb-dot{width:6px;height:6px;border-radius:50%;background:#9ca3af;display:inline-block;animation:scb-bounce 1s infinite ease-in-out}",
      ".scb-dot.d2{animation-delay:.15s}.scb-dot.d3{animation-delay:.3s}",
      "@keyframes scb-bounce{0%,80%,100%{transform:translateY(0);opacity:.45}40%{transform:translateY(-3px);opacity:1}}",
      ".scb-form{display:flex;gap:8px;padding:10px;border-top:1px solid #e5e7eb;background:#f5f6f9}",
      ".scb-input{flex:1;border:1px solid #d1d5db;border-radius:999px;padding:8px 12px;font-size:16px;outline:none;color:" + textColor + ";background:#fff}",
      ".scb-input:focus{border-color:" + accent + ";box-shadow:0 0 0 1px " + accent + "}",
      ".scb-send{border:1px solid " + accent + ";background:" + accent + ";color:" + textColor + ";border-radius:999px;padding:8px 12px;font-weight:700;cursor:pointer}",
      "@media (max-width:640px){.scb-root{left:0;right:0;bottom:0}.scb-root.open .scb-backdrop{display:block}.scb-toggle{position:fixed;right:max(8px,env(safe-area-inset-right,0px));bottom:max(8px,env(safe-area-inset-bottom,0px));padding:13px 20px;font-size:14px}.scb-panel{position:fixed;left:0;right:0;top:0;bottom:0;width:100%;height:100dvh;max-height:100dvh;border-radius:0;border:0;box-shadow:none;z-index:2}.scb-header{position:sticky;top:0;z-index:2;padding-top:calc(12px + env(safe-area-inset-top,0px));padding-left:calc(14px + env(safe-area-inset-left,0px));padding-right:calc(14px + env(safe-area-inset-right,0px))}.scb-messages{min-height:0;overflow-y:auto;padding-top:10px;padding-left:calc(10px + env(safe-area-inset-left,0px));padding-right:calc(10px + env(safe-area-inset-right,0px));padding-bottom:calc(72px + env(safe-area-inset-bottom,0px))}.scb-form{position:fixed;left:0;right:0;bottom:0;z-index:3;padding-left:calc(10px + env(safe-area-inset-left,0px));padding-right:calc(10px + env(safe-area-inset-right,0px));padding-bottom:calc(10px + env(safe-area-inset-bottom,0px));background:#fff;border-top:1px solid #e5e7eb}}"
    ].join("");
    var style = document.createElement("style");
    style.setAttribute("data-simple-chatbot", "1");
    style.textContent = css;
    document.head.appendChild(style);
  }

  function extractReply(data) {
    if (!data) return "";
    if (typeof data === "string") return data;
    return data.reply || data.text || data.message || data.output || "";
  }

  function postMessage(text) {
    sending = true;
    var payload = {
      chatInput: text,
      sessionId: sessionId(),
      metadata: {
        pageUrl: window.location.href,
        language: navigator.language || ""
      }
    };
    var url = webhookUrl + (webhookUrl.indexOf("?") === -1 ? "?action=sendMessage" : "&action=sendMessage");

    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.text().then(function (t) {
          if (!res.ok) throw new Error(t || "Request failed");
          try {
            return JSON.parse(t);
          } catch (_e) {
            return t;
          }
        });
      })
      .finally(function () {
        sending = false;
      });
  }

  function loadState(key, fallback) {
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return fallback;
      return JSON.parse(raw);
    } catch (_e) {
      return fallback;
    }
  }

  function saveState(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (_e) {}
  }

  function touchActivity() {
    try {
      localStorage.setItem(ACTIVITY_KEY, String(Date.now()));
    } catch (_e) {}
  }

  function clearExpiredData() {
    try {
      var raw = localStorage.getItem(ACTIVITY_KEY);
      if (!raw) return false;
      var last = parseInt(raw, 10);
      if (!last) return false;
      if (Date.now() - last <= INACTIVITY_TTL_MS) return false;
      localStorage.setItem(HISTORY_KEY, JSON.stringify([]));
      localStorage.removeItem(SESSION_KEY);
      localStorage.setItem(OPEN_KEY, JSON.stringify(false));
      localStorage.removeItem(ACTIVITY_KEY);
      return true;
    } catch (_e) {}
    return false;
  }

  function render() {
    addStyles();

    var root = document.createElement("div");
    root.className = "scb-root";
    root.innerHTML =
      '<div class="scb-backdrop" aria-hidden="true"></div>' +
      '<button type="button" class="scb-toggle" aria-label="' +
      title +
      '">' +
      toggleLabel +
      '</button>' +
      '<section class="scb-panel" aria-label="' +
      title +
      '">' +
      '<header class="scb-header"><div><div class="scb-title">' +
      title +
      '</div><div class="scb-sub">' +
      subtitle +
      '</div></div><button type="button" class="scb-close" aria-label="Close">×</button></header>' +
      '<div class="scb-messages"></div>' +
      '<form class="scb-form"><input class="scb-input" type="text" autocomplete="off" placeholder="' +
      placeholder +
      '" /><button type="submit" class="scb-send">' +
      sendLabel +
      "</button></form>" +
      "</section>";

    document.body.appendChild(root);

    var toggle = root.querySelector(".scb-toggle");
    var close = root.querySelector(".scb-close");
    var messages = root.querySelector(".scb-messages");
    var form = root.querySelector(".scb-form");
    var input = root.querySelector(".scb-input");
    var hasShownWelcome = false;

    function isMobileViewport() {
      return window.matchMedia && window.matchMedia("(max-width: 640px)").matches;
    }

    function lockBodyScroll() {
      if (!isMobileViewport()) return;
      var body = document.body;
      var html = document.documentElement;
      if (!body || !html || body.classList.contains("scb-lock-scroll")) return;
      body.classList.add("scb-lock-scroll");
      html.classList.add("scb-lock-scroll");
      html.style.overflow = "hidden";
      body.style.overflow = "hidden";
    }

    function unlockBodyScroll() {
      var body = document.body;
      var html = document.documentElement;
      if (!body || !html || !body.classList.contains("scb-lock-scroll")) return;
      body.classList.remove("scb-lock-scroll");
      html.classList.remove("scb-lock-scroll");
      html.style.overflow = "";
      body.style.overflow = "";
    }

    function escapeHtml(s) {
      return String(s)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    }

    function linkifySafe(text) {
      var escaped = escapeHtml(text || "");

      // Markdown links: [Label](https://example.com)
      escaped = escaped.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, function (_m, label, url) {
        return '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + label + "</a>";
      });

      // Raw URLs: https://example.com
      escaped = escaped.replace(/(^|[\s(])(https?:\/\/[^\s<]+)(?=$|[\s).,!?:;])/g, function (_m, prefix, url) {
        return prefix + '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + url + "</a>";
      });

      // Bold + italic markdown
      escaped = escaped.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
      escaped = escaped.replace(/(^|[\s(])\*([^*\n]+)\*(?=$|[\s).,!?:;])/g, "$1<em>$2</em>");

      var lines = escaped.split(/\n/);
      var html = "";
      var listOpen = false;
      var paragraph = [];

      function flushParagraph() {
        if (!paragraph.length) return;
        html += "<p>" + paragraph.join("<br>") + "</p>";
        paragraph = [];
      }

      function closeList() {
        if (!listOpen) return;
        html += "</ul>";
        listOpen = false;
      }

      for (var i = 0; i < lines.length; i++) {
        var line = lines[i];
        var trimmed = line.replace(/^\s+|\s+$/g, "");
        var bulletMatch = trimmed.match(/^[-*]\s+(.+)/);

        if (bulletMatch) {
          flushParagraph();
          if (!listOpen) {
            html += "<ul>";
            listOpen = true;
          }
          html += "<li>" + bulletMatch[1] + "</li>";
          continue;
        }

        if (!trimmed) {
          flushParagraph();
          closeList();
          continue;
        }

        closeList();
        paragraph.push(line);
      }

      flushParagraph();
      closeList();

      return html || escaped.replace(/\n/g, "<br>");
    }

    function addBubble(text, isUser, scrollMode) {
      if (!text) return;
      var row = document.createElement("div");
      row.className = "scb-row" + (isUser ? " user" : "");
      var bubble = document.createElement("div");
      bubble.className = "scb-bubble";
      if (isUser) {
        bubble.textContent = text;
      } else {
        bubble.innerHTML = linkifySafe(text);
      }
      row.appendChild(bubble);
      messages.appendChild(row);
      if (scrollMode !== "keep") {
        messages.scrollTop = messages.scrollHeight;
      }
    }

    function addLoaderBubble() {
      var row = document.createElement("div");
      row.className = "scb-row";
      var bubble = document.createElement("div");
      bubble.className = "scb-bubble loading";
      bubble.innerHTML = '<span class="scb-dot d1"></span><span class="scb-dot d2"></span><span class="scb-dot d3"></span>';
      row.appendChild(bubble);
      messages.appendChild(row);
      messages.scrollTop = messages.scrollHeight;
      return row;
    }

    function removeLoaderBubble(loaderEl) {
      if (loaderEl && loaderEl.parentNode) {
        loaderEl.parentNode.removeChild(loaderEl);
      }
    }

    function readHistory() {
      var parsed = loadState(HISTORY_KEY, []);
      return Array.isArray(parsed) ? parsed : [];
    }

    function writeHistory(next) {
      saveState(HISTORY_KEY, next.slice(-HISTORY_LIMIT));
    }

    function pushHistory(text, isUser) {
      var next = readHistory();
      next.push({ t: text, u: !!isUser });
      writeHistory(next);
      touchActivity();
    }

    function restoreHistory() {
      var next = readHistory();
      var hasBotMessage = false;
      for (var i = 0; i < next.length; i++) {
        var item = next[i];
        if (!item || !item.t) continue;
        addBubble(item.t, !!item.u, "keep");
        if (!item.u) hasBotMessage = true;
      }
      messages.scrollTop = 0;
      if (hasBotMessage) {
        messages.dataset.hasWelcome = "1";
        hasShownWelcome = true;
      }
    }

    function resetConversationUi() {
      messages.innerHTML = "";
      messages.dataset.hasWelcome = "";
      hasShownWelcome = false;
    }

    function handleSessionExpiryIfNeeded() {
      if (clearExpiredData()) {
        resetConversationUi();
        root.classList.remove("open");
        unlockBodyScroll();
      }
    }

    function open() {
      root.classList.add("open");
      saveState(OPEN_KEY, true);
      touchActivity();
      lockBodyScroll();
      if (welcomeMessage && !hasShownWelcome) {
        messages.dataset.hasWelcome = "1";
        hasShownWelcome = true;
        addBubble(welcomeMessage, false);
        pushHistory(welcomeMessage, false);
      }
      input.focus();
    }

    function closePanel() {
      root.classList.remove("open");
      saveState(OPEN_KEY, false);
      touchActivity();
      unlockBodyScroll();
    }

    handleSessionExpiryIfNeeded();
    restoreHistory();

    toggle.addEventListener("click", open);
    close.addEventListener("click", closePanel);
    window.addEventListener("resize", function () {
      if (root.classList.contains("open") && !isMobileViewport()) {
        unlockBodyScroll();
      } else if (root.classList.contains("open") && isMobileViewport()) {
        lockBodyScroll();
      }
    });
    window.addEventListener("pagehide", unlockBodyScroll);
    input.addEventListener("focus", function () {
      handleSessionExpiryIfNeeded();
      touchActivity();
    });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      handleSessionExpiryIfNeeded();
      var value = (input.value || "").trim();
      if (!value || sending) return;
      input.value = "";
      addBubble(value, true);
      pushHistory(value, true);
      var loader = addLoaderBubble();

      postMessage(value)
        .then(function (data) {
          removeLoaderBubble(loader);
          var reply = extractReply(data);
          var out = reply || "No response received. Please try again.";
          addBubble(out, false);
          pushHistory(out, false);
        })
        .catch(function () {
          removeLoaderBubble(loader);
          var out = "Connection problem. Please try again.";
          addBubble(out, false);
          pushHistory(out, false);
        });
    });

    if (loadState(OPEN_KEY, false)) {
      open();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", render);
  } else {
    render();
  }
})();
